module.exports = __webpack_public_path__ + "static/swiss-capital-icon-302e8836d6053f403ee00461674d6d6e.svg";